export default __webpack_public_path__ + "static/media/11.ce00eee6.webp";